module.exports = __webpack_public_path__ + "img/lg_ring_r_i_0_1@2x.db47fe47.png";